import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {CdkTreeModule} from '@angular/cdk/tree';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { A11yModule } from '@angular/cdk/a11y';
import { DateAdapter, MatNativeDateModule, MatOptionModule, MatRippleModule } from '@angular/material/core';
import { MatTreeModule } from '@angular/material/tree';
// -------------------
import {CdkAccordionModule} from '@angular/cdk/accordion';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {PortalModule} from '@angular/cdk/portal';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {CdkStepperModule} from '@angular/cdk/stepper';
import {CdkTableModule} from '@angular/cdk/table';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatBadgeModule} from '@angular/material/badge';
import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import {MatButtonModule} from '@angular/material/button';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatChipsModule} from '@angular/material/chips';
import {MatStepperModule} from '@angular/material/stepper';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
import {MatDividerModule} from '@angular/material/divider';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatSliderModule} from '@angular/material/slider';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import {MatTabsModule} from '@angular/material/tabs';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTooltipModule} from '@angular/material/tooltip';
import {OverlayModule} from '@angular/cdk/overlay';
import { HomeComponent } from './home/home.component';
import { StudentLoginComponent } from './student-login/student-login.component';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { BranchPatternMasterComponent } from './branch-pattern-master/branch-pattern-master.component';
import { AcademicSessionMasterComponent } from './academic-session-master/academic-session-master.component';
import { HttpTokenInterceptorService } from './http-token-interceptor.service';
import { DateFormat } from './date-format';
import { TeacherDataComponent } from './teacher-data/teacher-data.component';
import { FacultyDataComponent } from './faculty-data/faculty-data.component';
import { ParameterDataComponent } from './parameter-data/parameter-data.component';
import { ExamStreamDataComponent } from './exam-stream-data/exam-stream-data.component';
import { ParentsFormComponent } from './parents-form/parents-form.component';
import { ParentsDataComponent } from './parents-data/parents-data.component';
import { StudentDataComponent } from './student-data/student-data.component';
import { DistrictDataComponent } from './district-data/district-data.component';
import { CollegeDataComponent } from './college-data/college-data.component';
import { TownDataComponent } from './town-data/town-data.component';
import { DatePipe } from '@angular/common';
import { CodeTypeDataComponent } from './code-type-data/code-type-data.component';
import { SessionDataComponent } from './session-data/session-data.component';
import { ExamSemesterDataComponent } from './exam-semester-data/exam-semester-data.component';
import { ExamDivisionDataComponent } from './exam-division-data/exam-division-data.component';
import { CourseDataComponent } from './course-data/course-data.component';
import { ExamDataComponent } from './exam-data/exam-data.component';
import { ExamSubDataComponent } from './exam-sub-data/exam-sub-data.component';
import { IntegratedCourseDataComponent } from './integrated-course-data/integrated-course-data.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { AlertBoxComponent } from './alert-box/alert-box.component';
import { ModalpopService } from './modalpop.service';
import { ConformationModelComponent } from './conformation-model/conformation-model.component';
import { CodeDataComponent } from './code-data/code-data.component';
import { CollegeMappingComponent } from './college-mapping/college-mapping.component';
import { StateDataComponent } from './state-data/state-data.component';
import { DivisionDataComponent } from './division-data/division-data.component';
import { CountryDataComponent } from './country-data/country-data.component';
import { UsersComponent } from './users/users.component';
import { CourseBranchComponent } from './course-branch/course-branch.component';
import { SubjectMappingComponent } from './subject-mapping/subject-mapping.component';
import { ExamMasterComponent } from './exam-master/exam-master.component';
import { ExamAggregateComponent } from './exam-aggregate/exam-aggregate.component';
import { MapSubjectComponent } from './map-subject/map-subject.component';
import { ExamSubComponent } from './exam-sub/exam-sub.component';
import { ExamHeadComponent } from './exam-head/exam-head.component';
import { ExamSubjectSetupComponent } from './exam-subject-setup/exam-subject-setup.component';
import { ExamSubjectPopupComponent } from './exam-subject-popup/exam-subject-popup.component';
import { ExamTimetableComponent } from './exam-timetable/exam-timetable.component';
import { SessionCourseCollegeComponent } from './session-course-college/session-course-college.component';
import { SessionCutoffComponent } from './session-cutoff/session-cutoff.component';
import { StudentSettingsPageComponent } from './student-settings-page/student-settings-page.component';
import { ChoiceSubjectsComponent } from './choice-subjects/choice-subjects.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MatSelectFilterModule } from 'mat-select-filter';
import { ExamSubjectGradepointsPopComponent } from './exam-subject-gradepoints-pop/exam-subject-gradepoints-pop.component';
import { SupervisorCourseComponent } from './supervisor-course/supervisor-course.component';
import { SupervisorExamComponent } from './supervisor-exam/supervisor-exam.component';
import { ExamSettingPageComponent } from './exam-setting-page/exam-setting-page.component';
import { ExamScEditComponent } from './exam-sc-edit/exam-sc-edit.component';
import { CourseScEditComponent } from './course-sc-edit/course-sc-edit.component';
import { ExamScheduleComponent } from './exam-schedule/exam-schedule.component';
import { CourseScheduleComponent } from './course-schedule/course-schedule.component';
import { NewExamCodesComponent } from './new-exam-codes/new-exam-codes.component';
import { ResultProcessingOneComponent } from './result-processing-one/result-processing-one.component';
import { GenerateControlSheetsPoPComponent } from './generate-control-sheets-po-p/generate-control-sheets-po-p.component';
import { GenerateMarksFoilsPoPComponent } from './generate-marks-foils-po-p/generate-marks-foils-po-p.component';
import { GenerateRollNoPoPComponent } from './generate-roll-no-po-p/generate-roll-no-po-p.component';
import { AssignRegistrationNumberComponent } from './assign-registration-number/assign-registration-number.component';
import { CenterCodesComponent } from './center-codes/center-codes.component';
import { GenCodePopupComponent } from './gen-code-popup/gen-code-popup.component';
import { GenCodeUpdatePopupComponent } from './gen-code-update-popup/gen-code-update-popup.component';
import { QuestionPaperCodeComponent } from './question-paper-code/question-paper-code.component';
import { ExamInputFormComponent } from './exam-input-form/exam-input-form.component';
import { RegistrationFormComponent } from './registration-form/registration-form.component';
import { CenterAllocationComponent } from './center-allocation/center-allocation.component';
import { MarksEntryComponent } from './marks-entry/marks-entry.component';
import { ZoneComponent } from './zone/zone.component';
import { AssignVenueComponent } from './assign-venue/assign-venue.component';
import { PackingListComponent } from './packing-list/packing-list.component';
import { EnrollmentComponent } from './enrollment/enrollment.component';
import { AdmissionComponent } from './admission/admission.component';
import { EligibilityComponent } from './eligibility/eligibility.component';
import { IncentiveMarksComponent } from './incentive-marks/incentive-marks.component';
import { SubjectChangeComponent } from './subject-change/subject-change.component';
import { AssesmentMarksEntryComponent } from './assesment-marks-entry/assesment-marks-entry.component';
import { ReAddmissionComponent } from './re-addmission/re-addmission.component';
import { DebarExamLimitComponent } from './debar-exam-limit/debar-exam-limit.component';
import { TransferCourseComponent } from './transfer-course/transfer-course.component';
import { UpdatedResultComponent } from './updated-result/updated-result.component';
import { SubjectGraceComponent } from './subject-grace/subject-grace.component';
import { StudentStatusComponent } from './student-status/student-status.component';
import { PreviousExamComponent } from './previous-exam/previous-exam.component';
import { PaperEvaluatoionComponent } from './paper-evaluatoion/paper-evaluatoion.component';
import { QppopupComponent } from './qppopup/qppopup.component';
import { RevaluationResultComponent } from './revaluation-result/revaluation-result.component';
import { UserTabComponent } from './user-tab/user-tab.component';
import { UserMasterComponent } from './user-master/user-master.component';
import { PermissionComponent } from './permission/permission.component';
import { MasterComponent } from './master/master.component';
import { AdminComponent } from './admin/admin.component';
import { SupervisorComponent } from './supervisor/supervisor.component';
import { ProcessingComponent } from './processing/processing.component';
import { InputComponent } from './input/input.component';
import { ReportCourseComponent } from './report-course/report-course.component';
import { ReportExamComponent } from './report-exam/report-exam.component';
import { ReportFootersComponent } from './report-footers/report-footers.component';
import { AssignLevelsComponent } from './assign-levels/assign-levels.component';
import { ScrutinyComponent } from './scrutiny/scrutiny.component';
import { ScrutinyPopupComponent } from './scrutiny-popup/scrutiny-popup.component';
import { StudentDetailsComponent } from './student-details/student-details.component';
import { ChatComponent } from './chat/chat.component';
import { StudentHistoryComponent } from './student-history/student-history.component';
import { FeesHeadComponent } from './fees-head/fees-head.component';
import { FeeTempletComponent } from './fee-templet/fee-templet.component';
import { FeeTempletMappingComponent } from './fee-templet-mapping/fee-templet-mapping.component';
import { ApplyFeeTemplateComponent } from './apply-fee-template/apply-fee-template.component';
import { FeeSettingComponent } from './fee-setting/fee-setting.component';
import { FeeProcessComponent } from './fee-process/fee-process.component';
import { PaymentHistoryComponent } from './payment-history/payment-history.component';
import { FeesMasterComponent } from './fees-master/fees-master.component';
import { ReportsComponent } from './reports/reports.component';
import { HbsReportsComponent } from './hbsreports/hbsreports.component';
import { SettingComponent } from './setting/setting.component';
import { CollegeDialogBoxComponent } from './college-dialog-box/college-dialog-box.component';
import { CourseDialogBoxComponent } from './course-dialog-box/course-dialog-box.component';
import { FacultyDialogBoxComponent } from './faculty-dialog-box/faculty-dialog-box.component';
import { CodeTypeDialogBoxComponent } from './code-type-dialog-box/code-type-dialog-box.component';
import { ExamDialogBoxComponent } from './exam-dialog-box/exam-dialog-box.component';
import { TownDialogboxComponent } from './town-dialogbox/town-dialogbox.component';
import { DivisionDiaglogBoxComponent } from './division-diaglog-box/division-diaglog-box.component';
import { CountryDialogBoxComponent } from './country-dialog-box/country-dialog-box.component';
import { StateDialogBoxComponent } from './state-dialog-box/state-dialog-box.component';
import { DistrictDialogBoxComponent } from './district-dialog-box/district-dialog-box.component';
import { CodeDialogBoxComponent } from './code-dialog-box/code-dialog-box.component';
import { SessionCourseCollegeModelPopComponent } from './session-course-college-model-pop/session-course-college-model-pop.component';
import { SessionCutoffModelPopComponent } from './session-cutoff-model-pop/session-cutoff-model-pop.component';
import { FeeSettingDialogBoxComponent } from './fee-setting-dialog-box/fee-setting-dialog-box.component';
import { FeeTempletDialogBoxComponent } from './fee-templet-dialog-box/fee-templet-dialog-box.component';
import { FeeTempletMappingDialogBoxComponent } from './fee-templet-mapping-dialog-box/fee-templet-mapping-dialog-box.component';
import { FeeHeadDialogBoxComponent } from './fee-head-dialog-box/fee-head-dialog-box.component';
import { ExamEdidDialogBoxComponent } from './exam-edid-dialog-box/exam-edid-dialog-box.component';
import { ExamScheduleDialogBoxComponent } from './exam-schedule-dialog-box/exam-schedule-dialog-box.component';
import { UserDialogBoxComponent } from './user-dialog-box/user-dialog-box.component';
import { PermissionDialogBoxComponent } from './permission-dialog-box/permission-dialog-box.component';
import { RegistrationDialogBoxComponent } from './registration-dialog-box/registration-dialog-box.component';
import { CourseScheduleDialogBoxComponent } from './course-schedule-dialog-box/course-schedule-dialog-box.component';
import { SessionDataDialogBoxComponent } from './session-data-dialog-box/session-data-dialog-box.component';
import { MessageBoxComponent } from './message-box/message-box.component';
import { ReportsDashboardComponent } from './reports-dashboard/reports-dashboard.component';
import { PdfViewerComponent } from './pdf-viewer/pdf-viewer.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { StudentAtdComponent } from './student-atd/student-atd.component';
import { DefineGradeComponent } from './define-grade/define-grade.component';
import { SearchPipe } from './search.pipe';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { TehasilComponent } from './tehasil/tehasil.component';
import { TehasilDialogboxComponent } from './tehasil-dialogbox/tehasil-dialogbox.component';
import { ChartsModule } from 'ng2-charts';
import { UserToSubjectComponent } from './user-to-subject/user-to-subject.component';
import { SearchRegnFormsComponent } from './search-regn-forms/search-regn-forms.component';
import { PrintMsgBoxComponent } from './print-msg-box/print-msg-box.component';
import { RegnExamDataComponent } from './regn-exam-data/regn-exam-data.component';
import { RegnExamSubComponent } from './regn-exam-sub/regn-exam-sub.component';
import { SearchExamFormsComponent } from './search-exam-forms/search-exam-forms.component';
import { SearchExamSubComponent } from './search-exam-sub/search-exam-sub.component';
import { CollegePrintComponent } from './college-print/college-print.component';
import { StdAtdSettingsComponent } from './std-atd-settings/std-atd-settings.component';
import { CastWiseIntakeComponent } from './cast-wise-intake/cast-wise-intake.component';
import { IaAtdSettingComponent } from './ia-atd-setting/ia-atd-setting.component';
import { IaAtdComponent } from './ia-atd/ia-atd.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { TooltipComponent } from './tooltip/tooltip.component';
import { AdmFeeStudentsComponent } from './adm-fee-students/adm-fee-students.component';
import { ExamFeeStudentsComponent } from './exam-fee-students/exam-fee-students.component';
import { ScrutinyReportComponent } from './scrutiny-report/scrutiny-report.component';
import { FeeReportsComponent } from './fee-reports/fee-reports.component';
import { CamelcaseDirective } from './camelcase.directive';
import { UppercaseDirective } from './uppercase.directive';
import { ShortTableDirective } from './short-table.directive';
import { DownloadDetailsComponent } from './download-details/download-details.component';
import { PdfviewerComponent } from './pdfviewer/pdfviewer.component';
import { PayLaterComponent } from './pay-later/pay-later.component';
import { FeebypassComponent } from './feebypass/feebypass.component';
import { ExamFeeComponent } from './exam-fee/exam-fee.component';
import { ExamFeeProcessComponent } from './exam-fee-process/exam-fee-process.component';
import { PaymentReceiptComponent } from './payment-receipt/payment-receipt.component';
import { ReportmenuComponent } from './reportmenu/reportmenu.component';
import { HolidayDatesComponent } from './holiday-dates/holiday-dates.component';
import { HolidayDatesDialogComponent } from './holiday-dates-dialog/holiday-dates-dialog.component';
import { ParameterPopupComponent } from './parameter-popup/parameter-popup.component';
import { ComplaintComponent } from './complaint/complaint.component';
import { ComplaintFormComponent } from './complaint-form/complaint-form.component';
import { GrievanceActionComponent } from './grievance-action/grievance-action.component';
import { TransferScrutinyComponent } from './transfer-scrutiny/transfer-scrutiny.component';
import { TclcApprovalComponent } from './tclc-approval/tclc-approval.component';
import { CasteMasterComponent } from './caste-master/caste-master.component';
import { CasteMasterPopupComponent } from './caste-master-popup/caste-master-popup.component';
import { CategoryComponent } from './category/category.component';
import { CategoryPopupComponent } from './category-popup/category-popup.component';
import { TclcHistoryComponent } from './tclc-history/tclc-history.component';
import { PayGatewayComponent } from './pay-gateway/pay-gateway.component';
import { PayGatewayDialogComponent } from './pay-gateway-dialog/pay-gateway-dialog.component';
import { GrievanceApprovalLevelComponent } from './grievance-approval-level/grievance-approval-level.component';
import { TcDocumentUploadComponent } from './tc-document-upload/tc-document-upload.component';
import { WithHoldComponent } from './with-hold/with-hold.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { SlmComponent } from './slm/slm.component';
import { SlmDialogBoxComponent } from './slm-dialog-box/slm-dialog-box.component';
import { AdminNotificationsComponent } from './admin-notifications/admin-notifications.component';
import { TentativeScheduleComponent } from './tentative-schedule/tentative-schedule.component';
import { TentativeScheduleDetailsComponent } from './tentative-schedule-details/tentative-schedule-details.component';
import { TentativeScheduleMasterComponent } from './tentative-schedule-master/tentative-schedule-master.component';
// Datetime Picker Modules
// import { NgxMatDatetimePickerModule, NgxMatTimepickerModule, NgxMatNativeDateModule } from '@angular-material-components/datetime-picker';
// import { NgxMatMomentModule } from '@angular-material-components/moment-adapter';
// import * as moment from 'moment';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { TeacherProfileComponent } from './teacher-profile/teacher-profile.component';
import { DepartmentComponent } from './department/department.component';
import { DepartmentDialogBoxComponent } from './department-dialog-box/department-dialog-box.component';
import { DepartmentSubjectMappingComponent } from './department-subject-mapping/department-subject-mapping.component';
import { AssignTeacherComponent } from './assign-teacher/assign-teacher.component';
import { AssignTeacherDataComponent } from './assign-teacher-data/assign-teacher-data.component';
import { UpdateTeacherProfileComponent } from './update-teacher-profile/update-teacher-profile.component';
import { PracticalTimeTableComponent } from './practical-time-table/practical-time-table.component';
import { CollegeCapacityDiallogBoxComponent } from './college-capacity-diallog-box/college-capacity-diallog-box.component';
import { CenterAllocationDiallogBoxComponent } from './center-allocation-diallog-box/center-allocation-diallog-box.component';
import { CollegeCapacityComponent } from './college-capacity/college-capacity.component';
import { TeacherAvailibiltyComponent } from './teacher-availibilty/teacher-availibilty.component';
import { TeacherAvailibiltyDataComponent } from './teacher-availibilty-data/teacher-availibilty-data.component';
import { AvailableStatusComponent } from './available-status/available-status.component';
import { TeacherReportComponent } from './teacher-report/teacher-report.component';
import { ProviTeacherReportComponent } from './provi-teacher-report/provi-teacher-report.component';
import { ReProvisionalComponent } from './re-provisional/re-provisional.component';
import { StudentSignPhotoUploadComponent } from './student-sign-photo-upload/student-sign-photo-upload.component';
import { StudentSignPhotoUploadPopupComponent } from './student-sign-photo-upload-popup/student-sign-photo-upload-popup.component';
import { ExamFormReportCollegewiseComponent } from './exam-form-report-collegewise/exam-form-report-collegewise.component';
import { EligiblityForTeacherComponent } from './eligiblity-for-teacher/eligiblity-for-teacher.component';
import { EligiblityForTeacherPopupComponent } from './eligiblity-for-teacher-popup/eligiblity-for-teacher-popup.component';
import { IaMarksComponent } from './ia-marks/ia-marks.component';
import { IaUserAccessComponent } from './ia-user-access/ia-user-access.component';
import { IAMarkCountReportComponent } from './iamark-count-report/iamark-count-report.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { UploadStudentDataComponent } from './upload-student-data/upload-student-data.component';
import { OldStudentSigphUploadComponent } from './old-student-sigph-upload/old-student-sigph-upload.component';
import { OldStudentSigphUploadPopupComponent } from './old-student-sigph-upload-popup/old-student-sigph-upload-popup.component';
import { TeacherEligibilityComponent } from './teacher-eligibility/teacher-eligibility.component';
import { TeacherEligibilityDialogBoxComponent } from './teacher-eligibility-dialog-box/teacher-eligibility-dialog-box.component';
import { IAMarksReportComponent } from './ia-marks-report/ia-marks-report.component';
import { ConvocationComponent } from './convocation/convocation.component';
import { ConvocationPopupComponent } from './convocation-popup/convocation-popup.component';
import { PracticalBatchComponent } from './practical-batch/practical-batch.component';
import { PracticalMarksComponent } from './practical-markentry/practical-markentry.component';
import { StudentSignPhotoUploadReportComponent } from './student-sign-photo-upload-report/student-sign-photo-upload-report.component';
import { AdminOptionalSubjectSelectionComponent } from './admin-optional-subject-selection/admin-optional-subject-selection.component';
import { AdminOptionalSubjectPopupComponent } from './admin-optional-subject-popup/admin-optional-subject-popup.component';
import { TheoryExamAppointmentComponent } from './theory-exam-appointment-component/theory-exam-appointment-component.component';
import { TheoryExamAppointmentReportComponent } from './theory-exam-appointment-report/theory-exam-appointment-report.component';
import { ElectiveMarksComponent } from './elective-marks/elective-marks.component';
import { CollegewiseStudentNameListComponent } from './collegewise-student-name-list/collegewise-student-name-list.component';
import { StudentHoldDetailsComponent } from './student-hold-details/student-hold-details.component';
import { NewCenterAllocationComponent } from './new-center-allocation/new-center-allocation.component';
import { BatchFreezeComponent } from './batch-freeze/batch-freeze.component';
import { AssignPanelDateComponent } from './assign-panel-date/assign-panel-date.component';
import { SendEmailDialogComponent } from './send-email-dialog/send-email-dialog.component';
import { ReassignTeachersComponent } from './reassign-teachers/reassign-teachers.component';
import { ReassignFinalComponent } from './reassign-final/reassign-final.component';
import { MarksheetLedgerComponent } from './marksheet-ledger/marksheet-ledger.component';
import { ThirdPartyPayReceiptComponent } from './third-party-pay-receipt/third-party-pay-receipt.component';
import { PracticalMarksReportComponent } from './practical-marks-report/practical-marks-report.component';
import { MarksDataUploadSheetsComponent } from './marks-data-upload-sheets/marks-data-upload-sheets.component';
import { BufferStudentAnswersheetCodeEntryComponent } from './buffer-student-answersheet-code-entry/buffer-student-answersheet-code-entry.component';
import { BlockWiseReportComponent } from './block-wise-report/block-wise-report.component';
import { AttendanceSheetsComponent } from './attendance-sheets/attendance-sheets.component';
import { ExamsEvalMarksReportComponent } from './exams-eval-marks-report/exams-eval-marks-report.component';
import { CollegeMarksheetLedgerComponent } from './college-marksheet-ledger/college-marksheet-ledger.component';
import { CoursewiseAttThresoldMasterComponent } from './coursewise-att-thresold-master/coursewise-att-thresold-master.component';
import { EligibilityCriteriaComponent } from './eligibility-criteria/eligibility-criteria.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY hh:mm A',
  },
  display: {
    dateInput: 'DD/MM/YYYY hh:mm A',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@NgModule({
  declarations: [
    SearchPipe,
    AppComponent,
    HeaderComponent,
    HomeComponent,
    StudentLoginComponent,
    BranchPatternMasterComponent,
    AcademicSessionMasterComponent,
    TeacherDataComponent,
    FacultyDataComponent,
    ParameterDataComponent,
    ExamStreamDataComponent,
    ParentsFormComponent,
    ParentsDataComponent,
    StudentDataComponent,
    DistrictDataComponent,
    CollegeDataComponent,
    TownDataComponent,
    TownDataComponent,
    CodeTypeDataComponent,
    SessionDataComponent,
    ExamSemesterDataComponent,
    ExamDivisionDataComponent,
    CourseDataComponent,
    ExamDataComponent,
    ExamSubDataComponent,
    IntegratedCourseDataComponent,
    ForgotPasswordComponent,
    SignUpComponent,
    AlertBoxComponent,
    ConformationModelComponent,
    CodeDataComponent,
    CollegeMappingComponent,
    StateDataComponent,
    DivisionDataComponent,
    CountryDataComponent,
    UsersComponent,
    CourseBranchComponent,
    SubjectMappingComponent,
    ExamMasterComponent,
    ExamAggregateComponent,
    MapSubjectComponent,
    ExamSubComponent,
    ExamHeadComponent,
    ExamSubjectSetupComponent,
    ExamSubjectPopupComponent,
    ExamTimetableComponent,
    SessionCourseCollegeComponent,
    SessionCutoffComponent,
    StudentSettingsPageComponent,
    ChoiceSubjectsComponent,
    ExamSubjectGradepointsPopComponent,
    SupervisorCourseComponent,
    SupervisorExamComponent,
    ExamSettingPageComponent,
    ExamScEditComponent,
    CourseScEditComponent,
    ExamScheduleComponent,
    CourseScheduleComponent,
    NewExamCodesComponent,
    GenerateControlSheetsPoPComponent,
    GenerateRollNoPoPComponent,
    AssignRegistrationNumberComponent,
    CenterCodesComponent,
    GenCodePopupComponent,
    GenCodeUpdatePopupComponent,
    QuestionPaperCodeComponent,
    ResultProcessingOneComponent,
    ExamInputFormComponent,
    RegistrationFormComponent,
    CenterAllocationComponent,
    MarksEntryComponent,
    ZoneComponent,
    AssignVenueComponent,
    PackingListComponent,
    EnrollmentComponent,
    AdmissionComponent,
    EligibilityComponent,
    IncentiveMarksComponent,
    SubjectChangeComponent,
    AssesmentMarksEntryComponent,
    ReAddmissionComponent,
    DebarExamLimitComponent,
    TransferCourseComponent,
    UpdatedResultComponent,
    SubjectGraceComponent,
    StudentStatusComponent,
    PreviousExamComponent,
    PaperEvaluatoionComponent,
    QppopupComponent,
    RevaluationResultComponent,
    UserTabComponent,
    UserMasterComponent,
    PermissionComponent,
    MasterComponent,
    AdminComponent,
    SupervisorComponent,
    ProcessingComponent,
    InputComponent,
    ReportCourseComponent,
    ReportExamComponent,
    ReportFootersComponent,
    AssignLevelsComponent,
    ScrutinyComponent,
    ScrutinyPopupComponent,
    StudentDetailsComponent,
    ChatComponent,
    StudentHistoryComponent,
    FeesHeadComponent,
    FeeTempletComponent,
    FeeTempletMappingComponent,
    ApplyFeeTemplateComponent,
    FeeSettingComponent,
    FeeProcessComponent,
    PaymentHistoryComponent,
    FeesMasterComponent,
    ReportsComponent,
    HbsReportsComponent,
    SettingComponent,
    CollegeDialogBoxComponent,
    CourseDialogBoxComponent,
    FacultyDialogBoxComponent,
    CodeTypeDialogBoxComponent,
    ExamDialogBoxComponent,
    TownDialogboxComponent,
    DivisionDiaglogBoxComponent,
    CountryDialogBoxComponent,
    StateDialogBoxComponent,
    DistrictDialogBoxComponent,
    CodeDialogBoxComponent,
    SessionCourseCollegeModelPopComponent,
    SessionCutoffModelPopComponent,
    FeeSettingDialogBoxComponent,
    FeeTempletDialogBoxComponent,
    FeeTempletMappingDialogBoxComponent,
    FeeHeadDialogBoxComponent,
    ExamEdidDialogBoxComponent,
    ExamScheduleDialogBoxComponent,
    FeeHeadDialogBoxComponent,
    FeeTempletDialogBoxComponent,
    UserDialogBoxComponent,
    PermissionDialogBoxComponent,
    RegistrationDialogBoxComponent,
    CourseScheduleDialogBoxComponent,
    SessionDataDialogBoxComponent,
    MessageBoxComponent,
    ReportsDashboardComponent,
    PdfViewerComponent,
    StudentAtdComponent,
    DefineGradeComponent,
    ChangePasswordComponent,
    TehasilComponent,
    TehasilDialogboxComponent,
    UserToSubjectComponent,
    SearchRegnFormsComponent,
    PrintMsgBoxComponent,
    RegnExamDataComponent,
    RegnExamSubComponent,
    SearchExamFormsComponent,
    SearchExamSubComponent,
    CollegePrintComponent,
    StdAtdSettingsComponent,
    CastWiseIntakeComponent,
    IaAtdSettingComponent,
    IaAtdComponent,
    DashboardComponent,
    TooltipComponent,
    AdmFeeStudentsComponent,
    ExamFeeStudentsComponent,
    ScrutinyReportComponent,
    FeeReportsComponent,
    CamelcaseDirective,
    UppercaseDirective,
    ShortTableDirective,
    DownloadDetailsComponent,
    PdfviewerComponent,
    PayLaterComponent,
    FeebypassComponent,
    ExamFeeComponent,
    ExamFeeProcessComponent,
    PaymentReceiptComponent,
    ReportmenuComponent,
    HolidayDatesComponent,
    HolidayDatesDialogComponent,
    ParameterPopupComponent,
    ComplaintComponent,
    ComplaintFormComponent,
    GrievanceActionComponent,
    TransferScrutinyComponent,
    TclcApprovalComponent,
    CasteMasterComponent,
    CasteMasterPopupComponent,
    CategoryComponent,
    CategoryPopupComponent,
    TclcHistoryComponent,
    PayGatewayComponent,
    PayGatewayDialogComponent,
    GrievanceApprovalLevelComponent,
    TcDocumentUploadComponent,
    WithHoldComponent,
    NotificationsComponent,
    SlmComponent,
    SlmDialogBoxComponent,
    AdminNotificationsComponent,
    TentativeScheduleComponent,
    TentativeScheduleDetailsComponent,
    TentativeScheduleMasterComponent,
    TeacherProfileComponent,
    DepartmentComponent,
    DepartmentDialogBoxComponent,
    DepartmentSubjectMappingComponent,
    AssignTeacherComponent,
    AssignTeacherDataComponent,
    UpdateTeacherProfileComponent,
    PracticalTimeTableComponent,
    CollegeCapacityDiallogBoxComponent,
    CenterAllocationDiallogBoxComponent,
    CollegeCapacityComponent,
    TeacherAvailibiltyComponent,
    TeacherAvailibiltyDataComponent,
    AvailableStatusComponent,
    TeacherReportComponent,
    ProviTeacherReportComponent,
    ReProvisionalComponent,
    StudentSignPhotoUploadComponent,
    StudentSignPhotoUploadPopupComponent,
    ExamFormReportCollegewiseComponent,
    EligiblityForTeacherComponent,
    EligiblityForTeacherPopupComponent,
    IaMarksComponent,
    IaUserAccessComponent,
    IAMarkCountReportComponent,
    UploadStudentDataComponent,
    OldStudentSigphUploadComponent,
    OldStudentSigphUploadPopupComponent,
    TeacherEligibilityDialogBoxComponent,
    IAMarksReportComponent,
    ConvocationComponent,
    ConvocationPopupComponent,
    TeacherEligibilityComponent,
    PracticalBatchComponent,
    PracticalMarksComponent,
    StudentSignPhotoUploadReportComponent,
    AdminOptionalSubjectSelectionComponent,
    AdminOptionalSubjectPopupComponent,
    TheoryExamAppointmentComponent,
    TheoryExamAppointmentReportComponent,
    ElectiveMarksComponent,
    CollegewiseStudentNameListComponent,
    StudentHoldDetailsComponent,
    NewCenterAllocationComponent,
    BatchFreezeComponent,
   
     AssignPanelDateComponent,
    SendEmailDialogComponent,
    ReassignTeachersComponent,
    ReassignFinalComponent,
    MarksheetLedgerComponent,
    ThirdPartyPayReceiptComponent,
    PracticalMarksReportComponent,
    MarksDataUploadSheetsComponent,
    BufferStudentAnswersheetCodeEntryComponent,
    BlockWiseReportComponent,
    AttendanceSheetsComponent,
    ExamsEvalMarksReportComponent,
    CollegeMarksheetLedgerComponent,
    CoursewiseAttThresoldMasterComponent,
    EligibilityCriteriaComponent
  ],
imports:[
    MatFormFieldModule,
    MatOptionModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    CdkTreeModule,
    A11yModule,
    CdkAccordionModule,
    ClipboardModule,
    CdkStepperModule,
    CdkTableModule,
    CdkTreeModule,
    DragDropModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSelectFilterModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    OverlayModule,
    PortalModule,
    ScrollingModule,
    HttpClientModule,
    NgxSpinnerModule,
    PdfViewerModule,
    ChartsModule,
    // NgxMatDatetimePickerModule,
    // NgxMatTimepickerModule,
    // NgxMatNativeDateModule,
    // NgxMatMomentModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [{ provide: DateAdapter, useClass: DateFormat },
    { provide: MAT_DATE_LOCALE, useValue: 'en-IN' },
    // { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpTokenInterceptorService,
      multi: true
    },
    ModalpopService,DatePipe,SearchPipe
  ],
  bootstrap: [AppComponent],
  entryComponents: [AlertBoxComponent,ConformationModelComponent]
})
export class AppModule {
  constructor(private dateAdapter: DateAdapter<Date>) {

    dateAdapter.setLocale("en-in"); // DD/MM/YYYY
    
    }
 }
